<template>
    <section class="searchControl">
        <input class="searchControl__input" type="search" v-model="busqueda" placeholder="Buscar...">
        <div class="seleccionarVarios">
            <label @click="showCheckboxes"><input type="checkbox" id="cb-control">Seleccionar varios</label>
            <button class="button" @click="downloadSelection">Descargar <img src="../assets/download.png" alt="download"></button>
            <button class="button" v-if="this.$store.state.isAuth" @click="deleteSelection">Eliminar <img src="../assets/trash.png" alt="delete"></button>
        </div>
        <div class="filtrar">
            <p class="filtrar__text" @click="toogleFiltrar">Filtrar <img src="../assets/filter.png" alt="filter"></p>
            <div class="filtrar-tags hide" id="tags-div">
                <div class="tags">
                    <label class="tags__label" v-for="(tag, index) in tags" :key="tag + index"><input type="checkbox" name="filter-tag" :value="tag">{{tag}}</label>
                </div>
                <button class="button" @click="filterProduct">Aplicar <img src="../assets/check.png" alt="check"></button>
                <button class="button" @click="clearFilter">Limpiar <img src="../assets/clear.png" alt="clear"></button>
            </div>
        </div>
    </section>
    <section class="productsList">
        <SkeletonProduct v-if="this.$apollo.queries.products.loading"/>
        <SkeletonProduct v-if="this.$apollo.queries.products.loading"/>
        <SkeletonProduct v-if="this.$apollo.queries.products.loading"/>
        <div v-for="(product, index) in auxProducts" v-bind:key="product + index" class="productsList-item" @click="selectItem(product.id)">
            <input type="checkbox" :id="product.id" name="producto" :value="product.imageUrl" class="productsList-item__cb hide">
            <p>{{product.descripcion}} | ${{product.precio}}</p>
            <img :src="product.imageUrl" alt="producto" class="productsList-item__image">
            <div class="productsList-item__buttons">
                <button @click="downloadImage(product.imageUrl, $event)" class="button button-download">Descargar Imagen <img src="../assets/download.png" alt="download"></button>
                <router-link class="button" v-if="this.$store.state.isAuth" :to="{name: 'EditProduct', params: {imageUrl: product.imageUrl, id:product.id, tags:product.tags || [], precioP:product.precio, descripcion:product.descripcion}}" tag="li" @click.stop>Editar <img src="../assets/edit.png" alt="edit"></router-link>
                <button class="button" v-if="this.$store.state.isAuth" @click="deleteProduct(product.id, product.imageUrl, $event)">Eliminar <img src="../assets/trash.png" alt="delete"></button>
            </div>
        </div>
    </section>
</template>

<script>
import gql from "graphql-tag";
import axios from "axios";
import { storageRef, storage } from "../main";
import SkeletonProduct from "../components/SkeletonProduct.vue"
export default {
    name:"Home",
    data: ()=>{
        return{
            products: {},
            auxProducts: {},
            tags: {},
            busqueda: '',
        }
    },
    components:{SkeletonProduct},
    apollo: {
        products: {
            query: gql`
                query {
                    getAllProducts {
                        id
                        descripcion
                        imageUrl
                        precio
                        tags
                    }
                    }
                `,
                update: data => data.getAllProducts
        },
        tags: {
            query: gql`
            query {
                getAllProducts {
                    tags
                }
                }`,
                update: data => {
                    let list = [];
                    data.getAllProducts.forEach((item)=>{
                        if(item.tags != null){
                            item.tags.forEach((tag)=>{
                                if(!list.includes(tag)){
                                    list.push(tag);
                                }
                            })
                        }

                    });
                    return list;
                }
        }
    },
    methods: {
        downloadSelection(){
            const checked = document.querySelectorAll('input[name="producto"]:checked') || null;
            checked.forEach((item)=>{
                this.downloadImage(item.value);
                item.checked = false;
            })
        },
        async deleteSelection(){
            const checked = document.querySelectorAll('input[name="producto"]:checked') || null;

            let result = await this.$swal.fire({
            title: 'Estás seguro/a?',
            text: "No podras revertir esto!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar!'
            })

            if (result.isConfirmed) {
                checked.forEach(async (item)=>{
                await this.deleteOneProduct(item.id, item.value);
                item.checked = false;
                })
                
                this.refetchQueries()

                this.$swal.fire(
                'Eliminados!',
                'Los articulo seleccionados han sido eliminados.',
                'success'
                )         
            }

        },
        selectItem(productId){
            const checkboxSelected = document.getElementById(productId);
            checkboxSelected.checked = checkboxSelected.checked ? false : true;
        },
        downloadImage(imageUrl, event){
            if(event != null){
                event.stopPropagation();
            }

            let fileName = storage.refFromURL(imageUrl).name;
            axios({
                url: imageUrl,
                method: "GET",
                responseType: "blob",
            }).then((res) => {
                let file = window.URL.createObjectURL(new Blob([res.data]));
                let docUrl = document.createElement("a");
                docUrl.href = file;
                docUrl.setAttribute("download", fileName);
                document.body.appendChild(docUrl);
                docUrl.click();
            });
        },
        showCheckboxes(){
            const cbControl = document.getElementById('cb-control')
            if(cbControl.checked){
                const checked = document.querySelectorAll('input[name="producto"]') || null;
                checked.forEach((item)=>{
                    item.checked = false;
                    item.classList.remove("hide")
                })
            }else{
                const checked = document.querySelectorAll('input[name="producto"]') || null;
                checked.forEach((item)=>{
                    item.checked = false;
                    item.classList.add("hide")
                })
            }
            
        },
        toogleFiltrar(){
            const divFiltrar = document.getElementById('tags-div');
            divFiltrar.classList.toggle('hide')
        },
        async filterProduct(){
            const selectedTags = document.querySelectorAll('input[name="filter-tag"]:checked');
            if(selectedTags.length){
                this.auxProducts = this.products;
                this.auxProducts = this.products.filter((item)=>{
                    let found = false;
                    selectedTags.forEach((cb)=>{
                        if(item.tags !== null && item.tags.includes(cb.value)){
                            found = true;
                        }
                    })
                    if(found){
                        return item
                    }
                });
                this.reverseProductList();
            };
        },
        clearFilter(){
            const cbTags = document.querySelectorAll('input[name="filter-tag"]');
            cbTags.forEach((cb)=>{
                cb.checked = false;
            })
            this.auxProducts = [...this.products];
            this.reverseProductList();
        },
        searchProducts(busqueda){
            this.auxProducts = [...this.products];
            this.auxProducts = this.auxProducts.filter((item)=>{
                let descripcion = item.descripcion.toLowerCase();
                if(descripcion.includes(busqueda.toLowerCase())){
                    return item
                }else if(item.tags !== null && item.tags.includes(busqueda)){
                    return item
                };
            });
            this.reverseProductList();
        },
        async deleteProduct(idProduct, imageUrl, event){
            if(event != null){
                event.stopPropagation();
            }
            let result = await this.$swal.fire({
            title: 'Estás seguro/a?',
            text: "No podras revertir esto!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar!'
            })

            if (result.isConfirmed) {
                await this.deleteOneProduct(idProduct, imageUrl);
                this.refetchQueries()

                    this.$swal.fire(
                    'Eliminado!',
                    'El articulo ha sido eliminado.',
                    'success'
                    )         
            }
        },
        refetchQueries(){
            this.$apollo.queries.products.refetch();
            this.$apollo.queries.tags.refetch();
        },
        async deleteOneProduct(idProduct, imageUrl){
            try {
                    await this.$apollo.mutate({
                        mutation: gql`
                        mutation DeleteProduct($productId: String!) {
                                deleteProduct(productId: $productId)
                                }
                        `,
                        variables:{
                            productId: idProduct,
                        }
                    });

                    let fileName = storage.refFromURL(imageUrl).name;
                    let desertRef = storageRef.child("productos").child(fileName);
                    await desertRef.delete()

                } catch (error) {
                    console.error(error);
                }
        },
        reverseProductList(){
            this.auxProducts.reverse();
        }
    },
    watch: {
        products: function(val){
            this.auxProducts = [...val];
            this.reverseProductList();
        },
        busqueda: function(val){
            this.searchProducts(val);
        }
    },
    created(){
        this.refetchQueries();
    }
}
</script>

<style lang="scss">
.productsList{
    display: grid;
    grid-template-columns: 1fr;
    &-item{
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 1em;
        margin: .5em;
        border: 1px solid #ddd;
        border-radius: .5em;
        box-shadow: 0 0 4px #ddd;

        &__cb{
            position: absolute;
            top: .5em;
            left: .5em;
            z-index: -999;
        }

        &__image{
            width: 100%;
            margin: .5em;
        }

        &__buttons{
            display: flex;
            width: 100%;
            justify-content: space-between;
        }

        &__ul{
            list-style: none;
            width: 100%;
            display: flex;
            color: rgb(34, 3, 170);

            li{
                padding: .3em .5em;
            }
        }
    }
}
.searchControl{
    display: flex;
    margin: .5em;
    flex-wrap: wrap;

    &__input{
        width: 100%;
        border: 1px solid #ddd;
        padding: .3em .5em;
        border-radius: .5em;
        margin-bottom: .5em;
        font-size: 1em;
        outline: none;
        background: rgba(0, 0, 0, 0.02);

        &:focus{
            background: #FFF;
        }
    }

    .seleccionarVarios{
        display: flex;
        width: 100%;
        justify-content: space-between;
        margin: .5em 0;
        label{
            display: flex;
            align-items: center;
            input{
                margin-right: .1em;
            }
        }
    }
}
.tags{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    justify-items: start;
    grid-column-gap: .2em;
    grid-row-gap: .2em;
}
.hide{
    display: none;
}

.filtrar{
    width: 100%;
    &__text{
        color: #000;
        padding: .5em;
        width: fit-content;
        font-size: 16px;
        margin: 0 auto;
        border: 1px solid #ddd;
        cursor: pointer;

        img{
            vertical-align: middle;
        }
    }

    &-tags{
        border: 1px solid #ddd;
        border-radius: .5em;
        padding: .3em;
    }
}

@media (max-width: 360px) {
    .tags{
        grid-template-columns: repeat(3, 1fr);
    }
}
@media (min-width: 600px){
    .productsList{
        grid-template-columns: repeat(2, 1fr);
    }
}
@media (min-width: 950px){
    .productsList{
        grid-template-columns: repeat(3, 1fr);
    }
    .searchControl{
        justify-content: center;
        .seleccionarVarios{
            width: 50%;
            height: fit-content;
            justify-content: flex-start;
            margin: 0;
            & > * {
                margin-right: .9em;
            }
        }
        &__input{
            width: 80%;
        }
    }
    .filtrar{
        width: 50%;
        &__text{
            margin-left: 0px;
        }
        &-tags{
            border-top-left-radius: 0px;
        }
    }
}
@media (min-width: 1200px){
    .productsList{
        grid-template-columns: repeat(4, 1fr);
    }
    .searchControl{
        &__input{
            width: 60%;
        }
    }
}
</style>